import { Controller } from "@hotwired/stimulus"

// The x-apple-health:// scheme opens the Health app in real iOS Safari but
// silently no-ops elsewhere. The button is only rendered when the server
// classified the browser as iOS Safari (DeviceHelper), so this controller
// just lets the native navigation happen — the written steps below remain
// the reliable path regardless.
export default class extends Controller {
  open(event) {
    // Allow the default navigation to the x-apple-health:// URL. No preventDefault.
    // Hook point for instrumentation if we later want to measure deep-link taps.
  }
}
